module.exports = __webpack_public_path__ + "img/user-12.6f6bbb16.png";